module.exports = __webpack_public_path__ + "static/media/fb.c0afa340.svg";